module.exports = __webpack_public_path__ + "static/media/favicon-michelin_group_512x512.049b0b55.png";